module.exports = __webpack_public_path__ + "images/taco.14455e01e7257a645712.png";